module.exports = __webpack_public_path__ + "images/a58d493fd4abcac051bc399f58ad309c.svg";